import { BottomNav } from '@shared/ui/bottom-nav'
import { Footer } from '@shared/ui/footer'
import { HeroBanner } from './hero-banner'
import { HomeHeader } from './home-header'
import { ProductIntroSection } from './product-intro-section'

export function HomeView() {
  return (
    <>
      <HomeHeader />

      <div className="flex flex-1 flex-col pb-content-bottom">
        {/* Hero Banner */}
        <HeroBanner
          banner={{
            id: 'classic',
            tag: '정통 사주',
            title: '나를 읽는\n가장 깊은 방법',
            description: '명리학 기반 사주팔자 분석',
            cta: '무료로 시작하기',
            image: '/character-assets/1_landing_cleaned.png',
            gradient: 'from-primary/20 via-primary/5 to-transparent',
            href: '/saju/classic',
          }}
        />

        {/* 정통 사주 상품 소개 */}
        <ProductIntroSection />
      </div>

      <Footer />
      <BottomNav />
    </>
  )
}
